import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import classnames from 'classnames';
import { dfs, switchTypes, selectTypes, dateTypes, timeTypes, presetColumns } from '../../utils';
import { isValidType } from '@platform/template';

export default function useCellSelect(Table) {
    return class CellSelectTable extends Component {
        lastCellInfo = null;
        currentCellInfo = null; // 记录当前鼠标位置的单元格信息
        batchRange = []; // 批改时的区间，用于样式

        render() {
            let { cellSelectConfig = {}, cellProps, rowProps, columns, store } = this.props;
            let {
                enable,
                batchSelectEnable,
                disabledCell,
                selectedCell = new Map(),
                onSelect,
                onChange,
                exclude = [],
            } = cellSelectConfig;

            exclude = new Set(exclude);

            let copyCell = store.getCopiedCell();
            let isCopy = (row, col) => copyCell.get(row?.key)?.has(col?.attrcode);

            if (enable) {
                let nonSelection = !selectedCell.size;

                // 加边框
                columns = dfs(columns, column => {
                    if (column.isleaf) {
                        let oldRender = column.render;
                        let flatColumns = store.getVisibleLeafColumns();

                        let rows = store.getVisibleRows();
                        let colIndex = column.leafIndex;
                        column = {
                            ...column,
                            render: (row, viewIndex) => {
                                let hiddenBatch = column.itemtype == "refer" && !column.refcode;
                                let backgroundSize = ''; //决定哪个边框流动

                                if (isCopy(row, column)) {
                                    // 复制后的边框流动效果
                                    let prevRowIndex = viewIndex - 1,
                                        nextRowIndex = viewIndex + 1,
                                        prevColIndex = colIndex - 1,
                                        nextColIndex = colIndex + 1,
                                        noflowTop = prevRowIndex > -1 && isCopy(rows[prevRowIndex], flatColumns[colIndex]),
                                        // noflowTop = (prevRowIndex > -1 && isCopy(rows[prevRowIndex], flatColumns[colIndex])) || (prevRowIndex === -1 && copyCell.has(-1)),
                                        noflowBottom = nextRowIndex < rows.length && isCopy(rows[nextRowIndex], flatColumns[colIndex]),
                                        noflowRight = nextColIndex < flatColumns.length && isCopy(row, flatColumns[nextColIndex]),
                                        noflowLeft = prevColIndex > -1 && isCopy(row, flatColumns[prevColIndex]);

                                    if (noflowLeft) {
                                        backgroundSize += '0px 0px,';
                                    } else {
                                        backgroundSize += '2px 12px,';
                                    }

                                    if (noflowRight) {
                                        backgroundSize += '0px 0px,';
                                    } else {
                                        backgroundSize += '2px 12px,';
                                    }

                                    if (noflowTop) {
                                        backgroundSize += '0px 0px,';
                                    } else {
                                        backgroundSize += '12px 2px,';
                                    }

                                    if (noflowBottom) {
                                        backgroundSize += '0px 0px';
                                    } else {
                                        backgroundSize += '12px 2px';
                                    }
                                }
                                return <>
                                    {oldRender?.(row, viewIndex)}
                                    {this.isSelected(row, column) &&
                                        <div className={
                                            classnames({ "selector-border": !isCopy(row, column) },
                                            )
                                        }>
                                            {
                                                !exclude.has(column.key) &&
                                                batchSelectEnable &&
                                                !disabledCell?.(row.key, column.key) &&
                                                isValidType(column.itemtype) &&
                                                this.isSingleSelect() &&
                                                <div
                                                    className="batch-selector"
                                                    style={{ display: hiddenBatch ? 'none' : 'block' }}
                                                    onMouseDown={() => {
                                                        this.isBatchSelecting = true;
                                                        this.lastCursor = document.body.style.cursor;
                                                        document.body.style.cursor = 'crosshair';

                                                        let handleMouseUp = () => {
                                                            document.body.style.cursor = this.lastCursor;
                                                            this.lastCursor = null;
                                                            document.removeEventListener('mouseup', handleMouseUp);
                                                        };

                                                        document.addEventListener('mouseup', handleMouseUp);
                                                    }}
                                                    onDoubleClick={() => {
                                                        this.batchSelectorDoubleClick = true;
                                                        let cellValue = store.getCellValue(row.key, column.key),
                                                            visibleRows = store.getVisibleRows(),
                                                            oldValues = [];

                                                        visibleRows = visibleRows.slice(row.viewIndex + 1, visibleRows.length);

                                                        visibleRows = visibleRows.map(currentRow => {
                                                            oldValues.push(currentRow.values[column.key]);
                                                            return {
                                                                ...currentRow,
                                                                values: {
                                                                    ...currentRow.values,
                                                                    [column.key]: cellValue,
                                                                },
                                                            };
                                                        });

                                                        // selectedRows是更新后的值
                                                        onChange?.(visibleRows, {
                                                            column: column,
                                                            row: row,
                                                            oldValues,
                                                            texts: visibleRows.map(() => {
                                                                let itemtype = this.lastCellInfo.col.itemtype;

                                                                if (switchTypes.has(itemtype)) {
                                                                    if (cellValue?.value === 'Y' || cellValue?.value === true) {
                                                                        return true;
                                                                    }
                                                                    return false;
                                                                } else if (
                                                                    itemtype === 'number' ||
                                                                    selectTypes.has(itemtype) ||
                                                                    dateTypes.has(itemtype) ||
                                                                    timeTypes.has(itemtype)
                                                                ) {
                                                                    return cellValue?.value ?? '';
                                                                } else {
                                                                    return cellValue?._display_ ?? '';
                                                                }
                                                            }),
                                                            values: visibleRows.map(() => {
                                                                return cellValue?.value ?? '';
                                                            }),
                                                        });

                                                        this.batchSelectorDoubleClick = false;
                                                    }}
                                                ></div>
                                            }
                                        </div>
                                    }
                                    {
                                        isCopy(row, column) &&
                                        <div
                                            className={
                                                classnames({ "copy-border-flow": isCopy(row, column) }) //复制边框流动
                                            }
                                            style={{ backgroundSize: backgroundSize }}
                                        >
                                        </div>
                                    }

                                </>;
                            },
                        };
                    }
                    return column;
                });

                return (
                    <SelectModal {...this.props}>
                        <Table
                            {...this.props}
                            rowProps={(row, viewIndex) => {
                                let rawRowProps = rowProps?.(row, viewIndex) ?? {};
                                let onClick = e => {
                                    let startCell = this.lastCellInfo,
                                        endCell = this.currentCellInfo;
                                    if (startCell && endCell && startCell.row.key === endCell.row.key && startCell.col.key === endCell.col.key && !e.shiftKey && !e.ctrlKey) {
                                        // 只有单纯点击单元格才走rowClick
                                        rawRowProps?.onClick(e);
                                    }
                                };
                                if (selectedCell.has(row.key)) {
                                    return {
                                        ...rawRowProps,
                                        className: classnames(
                                            rawRowProps.className,
                                            'selected-row',
                                        ),
                                        onClick,
                                    };
                                }
                                return {
                                    ...rawRowProps,
                                    onClick,
                                };
                            }}
                            cellProps={(rowInfo, colInfo) => {
                                let { row, rowIndex: viewIndex, rows } = rowInfo,
                                    { col, colIndex, columns } = colInfo,
                                    rawCellProps = viewIndex < 0 ? {} : cellProps?.(rowInfo, colInfo) ?? {}; // 负数是表头的，不要执行回调

                                // if (!isValidType(col.itemtype)) {
                                //     return rawCellProps;
                                // }

                                let prevRowIndex = viewIndex - 1,
                                    nextRowIndex = viewIndex + 1,
                                    nextColIndex = colIndex + 1,
                                    prevColIndex = colIndex - 1;

                                let cellInfo = { ...rowInfo, ...colInfo };

                                return {
                                    ...rawCellProps,
                                    // 框选
                                    onMouseDownCapture: event => {
                                        if (event.target.className.includes('column-resize-handler')) {
                                            this.preventSelect = true;
                                            return;
                                        } else {
                                            this.preventSelect = false;
                                        }

                                        // 点击激活状态的单元格时，不触发框选
                                        // 因为需要选中文字
                                        let activeCell = store.getActiveCell();

                                        if (activeCell.rowKey === row.key && activeCell.colKey === col.key) {
                                            this.preventBatchSelect = true;
                                        } else {
                                            this.preventBatchSelect = false;
                                        }

                                        if (!findDOMNode(this).contains(event.target)) {
                                            return;
                                        }

                                        if (event.button !== 0 && selectedCell?.get(row.key)?.has(col.key)) { return; }

                                        if (!event.shiftKey) {
                                            this.lastCellInfo = cellInfo;
                                            this.snapshot = null;
                                        } else {
                                            if (!this.snapshot) {
                                                this.snapshot = JSON.parse(JSON.stringify(selectedCell));
                                            }
                                            if (!this.lastCellInfo) { // 直接shift选择，需要选中首行至选择行
                                                this.lastCellInfo = {
                                                    rowIndex: 0,
                                                    colIndex: 0,
                                                    columns,
                                                    rows,
                                                    row: rows[0],
                                                    col: columns[0],
                                                };
                                            }
                                        }
                                        this.currentCellInfo = cellInfo;
                                    },
                                    // 批改
                                    onMouseMove: event => {
                                        if (this.preventSelect || !findDOMNode(this).contains(event.target)) {
                                            return;
                                        }

                                        if (event.button !== 0 && selectedCell?.get(row.key)?.has(col.key)) {
                                            return;
                                        }

                                        if (this.isBatchSelecting) {
                                            event.stopPropagation();
                                            event.preventDefault();
                                        }
                                        this.currentCellInfo = cellInfo;
                                    },
                                    onMouseUp: event => {
                                        if (this.preventSelect || !findDOMNode(this).contains(event.target)) {
                                            return;
                                        }

                                        if (event.button !== 0 && selectedCell?.get(row.key)?.has(col.key)) {
                                            return;
                                        }

                                        if (!this.lastCellInfo) {
                                            return;
                                        }

                                        // 批改
                                        if (this.isBatchSelecting) {
                                            this.isBatchSelecting = false;

                                            let startIndex = this.lastCellInfo.row.viewIndex,
                                                endIndex = this.currentCellInfo.row.viewIndex,
                                                selectedRows,
                                                baseRow = rows[startIndex],
                                                oldValues = [];

                                            if (startIndex === endIndex) { return; } //单个单元格时不触发

                                            // 要把批改的基准行排除——NCC-228164
                                            if (startIndex > endIndex) {
                                                selectedRows = rows.slice(endIndex, startIndex);
                                            } else {
                                                selectedRows = rows.slice(startIndex + 1, endIndex + 1);
                                            }

                                            selectedRows = selectedRows.map(row => {
                                                let colKey = this.lastCellInfo.col.key;
                                                oldValues.push(row.values[colKey]);
                                                return {
                                                    ...row,
                                                    values: {
                                                        ...row.values,
                                                        [colKey]: baseRow.values[this.lastCellInfo.col.key],
                                                    },
                                                };
                                            });

                                            // selectedRows是更新后的值
                                            onChange?.(selectedRows, {
                                                column: this.lastCellInfo.col,
                                                row: rows[startIndex],
                                                oldValues,
                                                texts: selectedRows.map(() => {
                                                    let cellValue = baseRow.values[this.lastCellInfo.col.key],
                                                        itemtype = this.lastCellInfo.col.itemtype;

                                                    if (switchTypes.has(itemtype)) {
                                                        if (cellValue?.value === 'Y' || cellValue?.value === true) {
                                                            return true;
                                                        }
                                                        return false;
                                                    } else if (
                                                        itemtype === 'number' ||
                                                        selectTypes.has(itemtype) ||
                                                        dateTypes.has(itemtype) ||
                                                        timeTypes.has(itemtype)
                                                    ) {
                                                        return cellValue?.value ?? '';
                                                    } else {
                                                        return cellValue?._display_ ?? '';
                                                    }
                                                }),
                                                values: selectedRows.map(() => {
                                                    let cellValue = baseRow.values[this.lastCellInfo.col.key];

                                                    return cellValue?.value ?? '';
                                                }),
                                            });

                                            let startCell = this.lastCellInfo,
                                                // 只能批改当列的
                                                endCell = { ...cellInfo, col: this.lastCellInfo.col, colIndex: this.lastCellInfo.colIndex };

                                            selectedCell = this.rangeSelect(
                                                startCell,
                                                endCell,
                                                { pattern: 'replace' },
                                            );

                                            onSelect?.(selectedCell, { startCell, endCell, batchSelect: true });
                                            return;
                                        }

                                        if (this.preventBatchSelect) {
                                            this.preventBatchSelect = false;
                                            return;
                                        }

                                        let action;

                                        if (event.shiftKey) {
                                            action = 'shift';

                                            event.preventDefault();
                                            selectedCell = this.rangeSelect(this.lastCellInfo, cellInfo, { pattern: 'merge' });
                                        } else if (event.metaKey || event.ctrlKey) {
                                            action = 'ctrl';

                                            // 连续单选
                                            event.preventDefault();
                                            selectedCell = this.rangeSelect(this.lastCellInfo, cellInfo, { pattern: 'toggle' });
                                        } else {
                                            action = 'down';

                                            // 单选 && 框选
                                            selectedCell = this.rangeSelect(this.lastCellInfo, cellInfo, { pattern: 'replace' });
                                        }

                                        // 优化：选中前后没变化，不更新
                                        // 但是这里只处理了前后都是空的情况
                                        if (nonSelection && !selectedCell.size) {
                                            return;
                                        }

                                        onSelect?.(selectedCell, { startCell: this.lastCellInfo, endCell: cellInfo, action });
                                    },
                                    isCopy: isCopy({ key: -1 }, col),
                                    // rowIndex小于0是表头
                                    className: viewIndex < 0 ?
                                        classnames({ 'selected-cell': this.isSelected(row, col) }) :
                                        classnames(
                                            rawCellProps.className,
                                            'selected-cell-enabled',
                                            {
                                                'selected-cell': this.isSelected(row, col),
                                                'no-border-right': nextColIndex < columns.length && this.isSelected(row, columns[nextColIndex]),
                                                'no-border-top': prevRowIndex > -1 && this.isSelected(rows[prevRowIndex], col),
                                                'no-border-bottom': nextRowIndex < rows.length && this.isSelected(rows[nextRowIndex], col),
                                            },
                                        ),
                                };
                            }}
                            columns={columns}
                        />
                    </SelectModal>
                );
            } else {
                return <Table {...this.props}></Table>;
            }
        }

        componentDidMount() {
            window.addEventListener('mousedown', this.outsideClick);
        }

        componentWillUnmount() {
            window.removeEventListener('mousedown', this.outsideClick);
        }

        getTopContainer = element => {
            let lastParent = element,
                parent = null;
            // 解决模态框中的情况
            while (lastParent) {
                parent = lastParent.parentNode;
                if (parent && parent !== document.body) {
                    lastParent = parent;
                } else {
                    break;
                }
            }
            return lastParent;
        };

        outsideClick = event => {
            let { cellSelectConfig = {} } = this.props,
                { onSelect, selectedCell } = cellSelectConfig;
            let tableBodyArea = findDOMNode(this).querySelector('table.table-next-body'),
                tableHeaderArea = findDOMNode(this).querySelector('table.table-next-header');

            if (this.getTopContainer(event.target) === this.getTopContainer(tableBodyArea) &&
                !tableBodyArea?.contains(event.target) &&
                !tableHeaderArea?.contains(event.target)) {
                this.lastCellInfo = null;
                this.currentCellInfo = null;
                if (selectedCell?.size) {
                    if (findDOMNode(this).contains(event.target)) {
                        onSelect?.(new Map(), { startCell: null, endCell: null, action: 'down' });
                    } else {
                        onSelect?.(new Map(), { startCell: null, endCell: null, action: null });
                    }
                }
            }
        }

        isSelected = (row, col) => {

            let { cellSelectConfig } = this.props,
                { selectedCell = new Map() } = cellSelectConfig,
                rowKey = row.key,
                colKey = col.key;
            return selectedCell?.get(rowKey)?.has(colKey);
        }

        isSingleSelect = () => {
            let { cellSelectConfig } = this.props,
                { selectedCell = new Map() } = cellSelectConfig;

            selectedCell = [...selectedCell];

            return selectedCell.length === 1 && selectedCell[0][1].size === 1;
        }

        rangeSelect = (startInfo = {}, endInfo, { pattern }) => {
            let {
                    rows,
                    columns,
                    rowIndex: firstRow,
                    colIndex: firstCol,
                } = startInfo,
                {
                    rowIndex: lastRow,
                    colIndex: lastCol,
                } = endInfo,
                { cellSelectConfig = {}, rowKey: getRowKey } = this.props;

            let { selectedCell = new Map(), exclude = [] } = cellSelectConfig;
            exclude = new Set(exclude);

            if (this.snapshot) {
                selectedCell = new Map(this.snapshot.map(key_value => {
                    key_value = [...key_value];
                    key_value[1] = new Set(key_value[1]);
                    return key_value;
                }));
            }

            if (pattern === 'replace') {
                selectedCell = new Map();
            }

            if (firstRow > lastRow) {
                [firstRow, lastRow] = [lastRow, firstRow];
            }

            if (firstCol > lastCol) {
                [firstCol, lastCol] = [lastCol, firstCol];
            }

            // 框选单个表头，不处理
            if (firstRow === lastRow && firstCol === lastCol && firstRow < 0) {
                return selectedCell;
            }

            for (let viewIndex = firstRow; viewIndex <= lastRow; viewIndex++) {
                let rowKey;
                if (viewIndex < 0) { // 表头的rowKey用索引表示
                    rowKey = viewIndex;
                } else {
                    rowKey = getRowKey(rows[viewIndex], viewIndex);
                }
                for (let colIndex = firstCol; colIndex <= lastCol; colIndex++) {
                    let colKey = columns[colIndex].key,
                        rowSelectInfo = selectedCell.get(rowKey);

                    if (exclude.has(colKey) || !columns[colIndex].selectable) {
                        continue;
                    }

                    if (rowSelectInfo) {
                        if (pattern === 'toggle') {
                            rowSelectInfo.has(colKey) ? rowSelectInfo.delete(colKey) : rowSelectInfo.add(colKey);
                            if (!rowSelectInfo.size) { // 如果空集合就删除吧
                                selectedCell.delete(rowKey);
                            }
                        } else {
                            rowSelectInfo.add(colKey);
                        }
                    } else {
                        selectedCell.set(rowKey, new Set([colKey]));
                    }
                }
            }

            this.startInfo = null;
            this.endInfo = null;

            return selectedCell;
        }
    };
}

useCellSelect.displayName = 'useCellSelect';
useCellSelect.dependence = [];
useCellSelect.hooks = function () {
    this.store.selectedCell = new Map();
    this.store.borderBackgroundSize = {};
    return {
        setSelectedCell: selectedCell => {
            this.store.selectedCell = selectedCell || new Map();
            this.forceUpdate();
        },
        getSelectedCell: () => {
            return this.store.selectedCell;
        },
        setCopiedCell: copyCell => {
            this.store.copyCell = copyCell || new Map();
            this.forceUpdate();
        },
        getCopiedCell: () => {
            return this.store.copyCell || new Map();
        },
    };
};
useCellSelect.propsGenerator = function (props) {
    let { cellSelectConfig = {}, store } = props;

    let { enable, batchSelectEnable, onSelect, beforeSelect } = cellSelectConfig;

    if (!enable) {
        return props;
    }

    cellSelectConfig = {
        ...cellSelectConfig,
        batchSelectEnable: batchSelectEnable && store.getStatus() !== 'browse',
        selectedCell: store.getSelectedCell(),
        copiedCell: store.getCopiedCell(),
        disabledCell: (rowKey, colKey) => {
            return store.getCellProps(rowKey, colKey, 'disabled');
        },
        onSelect: (selectedCell, { startCell, endCell, batchSelect, action }) => {
            if (beforeSelect && !beforeSelect(action)) { return; }

            store.setSelectedCell(selectedCell);
            store.setCopiedCell(new Map()); //清空复制单元格
            // 框选单个单元格不触发onSelect（特指action为down的，shift/ctrl等除外）
            if (!(startCell && endCell && startCell.row.key === endCell.row.key && startCell.col.key === endCell.col.key && action === 'down')) {
                if ([...selectedCell.keys()].some(key => !presetColumns.has(key))) {
                    onSelect?.(selectedCell, { startCell, endCell, batchSelect, action });
                }
            }
        },
    };

    return {
        ...props,
        cellSelectConfig,
    };
};
class SelectModal extends Component {
    render() {
        let { flex, store } = this.props;
        return <div
            className={classnames("cell-selector-wrapper", { 'flex-container': flex })}
            onMouseDownCapture={event => {
                this.zoom = document.body.style.zoom || 1;

                // 点击激活状态的单元格时，不触发框选
                // 因为需要选中文字
                let activeCellInstance = store.getInstance().getComponent(
                        store.getInstance().itemIDManager.getID(store.getActiveCell()),
                    ),
                    activeCell = activeCellInstance && findDOMNode(activeCellInstance.current);

                if (activeCell?.contains(event.target) || event.button !== 0) {
                    return;
                }

                // TableBody和tableHeader可框选
                let isHeaderArea = event.currentTarget.querySelector('.table-next-header-wrapper')?.contains(event.target);
                if (
                    (!event.currentTarget.querySelector('.table-next-body-wrapper')?.contains(event.target) &&
                        !isHeaderArea) ||
                    event.target.className.includes('column-resize-handler') ||
                    event.target.matches('.card-table-expanded-row *')
                ) {
                    return;
                }
                let startX, startY;
                startX = event.clientX / this.zoom, startY = event.clientY / this.zoom;

                let modal = document.createElement('div');
                modal.style.position = 'fixed';
                modal.style.pointerEvents = 'none';
                modal.style.background = 'rgba(50, 128, 252, 0.2)';
                modal.style.zIndex = 9999;
                document.body.appendChild(modal);

                let clientWidth = document.documentElement.clientWidth / this.zoom,
                    clientHeight = document.documentElement.clientHeight / this.zoom;

                // 这种写法不会导致重绘
                const handleSelectstart = event => {
                    event.preventDefault();
                };

                const handleMouseMove = event => {
                    event.preventDefault();

                    let endX = event.clientX / this.zoom, endY = event.clientY / this.zoom;

                    if (endX > startX) {
                        modal.style.width = `${endX - startX}px`;
                        modal.style.left = `${startX}px`;
                        modal.style.right = 'auto';
                    } else {
                        modal.style.width = `${startX - endX}px`;
                        modal.style.right = `${clientWidth - startX}px`;
                        modal.style.left = 'auto';
                    }

                    if (endY > startY) {
                        modal.style.height = `${endY - startY}px`;
                        modal.style.top = `${startY}px`;
                        modal.style.bottom = 'auto';
                    } else {
                        modal.style.height = `${startY - endY}px`;
                        modal.style.bottom = `${clientHeight - startY}px`;
                        modal.style.top = 'auto';
                    }
                };

                const handleMouseUp = () => {
                    document.body.removeChild(modal);

                    window.removeEventListener('mousemove', handleMouseMove);
                    window.removeEventListener('mouseup', handleMouseUp);
                    window.removeEventListener('selectstart', handleSelectstart);
                    document.body.removeEventListener('mouseleave', handleMouseUp);
                };

                window.addEventListener('selectstart', handleSelectstart);
                window.addEventListener('mousemove', handleMouseMove);
                window.addEventListener('mouseup', handleMouseUp);
                document.body.addEventListener('mouseleave', handleMouseUp);
            }}
        >
            {this.props.children}
        </div>;
    }
}